import { Product } from './product';

export class ProductDiscount {
    id = 0;
    product_id = 0;
    external_code = '';
    type = 0;
    percent = 0;
    title = '';
    from = '';
    to = '';
    status = 0;
    //created_at = '';
    //updated_at = '';
    deleted = 0;

    product = new Product();
}
